<template>
  <div class="item-card item-card--skeleton">
    <div class="item-card__image"></div>
    <div class="item-card__content">
      <div class="item-card__name"></div>
      <div class="item-card__row">
        <p class="item-card__text"></p>
        <p class="item-card__text"></p>
        <p class="item-card__text grey-color"></p>
      </div>
      <p class="item-card__text"></p>
      <p class="item-card__text"></p>
      <div class="item-card__button">
        <a href="javascript:void(0)" class="item-card__button-link"></a>
      </div>
    </div>
  </div>
</template>